// The workspace's pages and its sidebar (components/AppSidebar.js draws it). A page's key is its URL (/app/<key>) and its
// sidebar button's id (#<key>; #mobile-<key> in the phone menu) - the walkthroughs point at those (reacttour/StartTour.js).
import { BarChart3, Box, Building2, History, LayoutDashboard, Library, PlusCircle, Settings } from "lucide-react";

export const TABS = [
  { key: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { key: "studio", label: "My Simulations", icon: Box },
  { key: "results", label: "Results", icon: BarChart3 },
  { key: "items", label: "Library", icon: Library },
  { key: "audit", label: "Audit", icon: History },
  { key: "settings", label: "Settings", icon: Settings },
];

const tab = (key) => TABS.find((t) => t.key === key);

// The sidebar, in groups: pages, and shortcuts into one (`to`) - Create opens the Studio's new plan, Organization the members.
export const NAV = [
  [tab("dashboard"), { key: "create", label: "Create", icon: PlusCircle, to: "/app/studio?new=1" }, tab("studio"), tab("results")],
  [tab("items"), { key: "organization", label: "Organization", icon: Building2, to: "/app/settings?section=members" }, tab("audit"),
    tab("settings")],
];
